export default __webpack_public_path__ + "static/media/Bitmap_11.5506f7b6.jpg";